'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormField = FormField;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./field.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Form Field
 *
 * This is a low-level component meant to display a label and form control
 * combination.
 *
 * @example
 * import { Field } from 'common/components/forms';
 * import Input from 'common/components/input';
 *
 * <Field label='Email Address'>
 *      <Input {...someProps} />
 * </Field>
 */
function FormField(props) {
    var label = props.label;


    return _react2['default'].createElement(
        'div',
        { className: 'm-field' },
        label && _react2['default'].createElement(
            'label',
            { className: 'm-field--label' },
            label
        ),
        props.children
    );
}

FormField.propTypes = {
    label: _react.PropTypes.string,
    children: _react.PropTypes.node
};

exports['default'] = FormField;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/forms/field.jsx
 ** module id = 1004
 ** module chunks = 0
 **/